<template>
    <el-table
        class="account-log-table"
        max-height="500"
        stripe
        :data="data"
        v-loading="isLoading">
        <el-table-column
            label="Company Name"
            prop="action"
            fixed>
            <template v-slot="scope">
                <div>
                    {{ scope.row?.company?.name }}
                </div>
            </template>
        </el-table-column>
        <el-table-column
            label="Aloware Admin User"
            fixed>
            <template v-slot="scope">
                {{ getReviewedByUser(scope.row) }}
            </template>
        </el-table-column>
        <el-table-column
            label="Notes"
            prop="notes"
            fixed>
            <template v-slot="scope">
                <div>
                    {{ scope.row.notes }}
                </div>
            </template>
        </el-table-column>
        <el-table-column
            label="Date"
            prop="date"
            sortable
            fixed>
            <template v-slot="scope">
                {{ scope.row.created_at | fixFullDateLocal }}
            </template>
        </el-table-column>
        <el-table-column
            label="KYC Status"
            prop="kyc_status"
            sortable
            fixed>
            <template v-slot="scope">
                <div class="d-flex align-items-center">
                    <div class="status-badge"
                        :class="[`status-badge-${parseStatusValue(scope.row.kyc_status)}`]">
                    </div>
                    <div class="ml-2">
                        {{ parseStatus(scope.row.kyc_status) }}
                    </div>
                </div>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import kycStatuses from "../../constants/compliance-kyc-statuses"

export default {
    name: "KycAccountLogTable",

    props: {
        data: {
            type: Array,
            required: true
        },

        parseStatus: {
            type: Function,
            required: true
        },

        parseStatusValue: {
            type: Function,
            required: true
        },

        isLoading: {
            type: Boolean,
            required: true
        }
    },

    data() {
        return {
            kycStatuses
        }
    },

    methods: {
        parseActionStatus (actionStatus) {
            switch (actionStatus) {
                case 'REVIEW':
                    return 'Review';
                case 'NOTE_ADDED':
                    return 'Note added';
                default:
                    return 'Review';
            }
        },

        getReviewedByUser (row) {
            if (row?.admin?.full_name) {
                return row.admin.full_name
            }

            if (row?.admin?.first_name && row?.admin?.last_name) {
              return `${row.admin.first_name} ${row.admin.last_name}`
            }

            if (row?.admin?.email) {
                return row.admin.email
            }

            return ''
        },
    }
}
</script>
